const $ = jQuery.noConflict();
/* eslint-disable */
import Global from '../shared/global';

'use strict';
const AddToCart = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		// this.addToCart();
		jQuery(document).on('adding_to_cart', function(e) {
			document.body.classList.add('loader-visible');
			const ele = e.currentTarget.activeElement;
			if (ele.parentElement.querySelector('.js-msg-added-to-cart-success')) {
				ele.parentElement.querySelector('.js-msg-added-to-cart-success').remove();
			}
			ele.style.pointerEvents = 'none';
			ele.style.opacity = '0.5';
		});

		jQuery(document).on('added_to_cart', function(e) {
			const ele = e.currentTarget.activeElement;
			ele.style.pointerEvents = 'auto';
			ele.style.opacity = '1';
			const msg = $('<span class="msg-added-to-cart-success js-msg-added-to-cart-success">Dodato u korpu</span>');
			$(msg).insertAfter(ele);
			setTimeout(function() {
				msg.remove();
			}, 5000);
		});
	},

	addToCart: function() {
		const buttons = document.querySelectorAll('.add_to_cart_button');

		if (buttons.length < 1) {
			return false;
		}

		const handleClick = async (e) => {
			e.preventDefault();
			const ele = e.currentTarget;
			const productId = ele.getAttribute('data-product_id');
			const qty = ele.getAttribute('data-quantity');
			ele.style.pointerEvents = 'none';
			ele.style.opacity = '0.5';
			const data = {
				action: 'add_to_cart_single',
				productId,
				qty
			};

			await AddToCart.ajaxFunction(data, ele);
		};

		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', handleClick);
		}
	},

	ajaxFunction: function(data, ele) {
		$.ajax({
			datatype: 'json',
			type: 'POST',
			url: window.techno_ferum_ajax.ajax_url,
			data,
			success: function(response) {
				console.log(response);
				if (response.success) {
					const countBadgeHtml = document.querySelector('.js-cart-count-badge');
					countBadgeHtml.innerText = response.data;
					ele.style.pointerEvents = 'auto';
					ele.style.opacity = '1';
					const msg = $('<span class="msg-added-to-cart-success js-msg-added-to-cart-success">Dodato u korpu</span>');
					$(msg).insertAfter(ele);
					setTimeout(function() {
						msg.remove();
					}, 5000);
				}
			}
		});
	}
};

export default AddToCart;
